<div class="navbar navbar-dark bg-dark box-shadow">
  <div class="container-fluid d-flex justify-content-between">
    <div class="d-flex align-items-center">
      @if (loading()) {
        <kendo-loader type="converging-spinner" size="small" themeColor="base" class="push-left me-2"></kendo-loader>
      }
      @if (title()) {
        <div class="navbar-brand d-flex align-items-center">
          {{title()}}
        </div>
      }
    </div>
    <ng-content></ng-content>
  </div>
</div>